import React from 'react';
import { Box, MenuItem, Select, SelectProps } from '@material-ui/core';

type Props = {
  page: number;                    
  pageSize: number;                
  total: number;                     
  onChangePageSize: (n: number) => void;
  options?: number[];
  className?: string;
};

const MENU_PROPS: SelectProps['MenuProps'] = {
  disablePortal: true,
  getContentAnchorEl: null as any,
  anchorOrigin: { vertical: 'top', horizontal: 'left' },
  transformOrigin: { vertical: 'bottom', horizontal: 'left' },
  PaperProps: { style: { zIndex: 2005, maxHeight: 260 } } as any,
};

const ModalRowsSelect: React.FC<Props> = ({
  page,
  pageSize,
  total,
  onChangePageSize,
  options = [6, 12, 18, 24],
  className,
}) => {
  const safe = options.includes(pageSize) ? pageSize : options[0];

  const start = total === 0 ? 0 : (page - 1) * safe + 1;
  const end = Math.min(page * safe, total);

  return (
    <Box className={`modal-rows-select ${className || ''}`} display="flex" alignItems="center">
      <span className="mrs-label">Mostrando:</span>
      <Select
        value={safe}
        onChange={(e) => onChangePageSize(Number(e.target.value))}
        MenuProps={MENU_PROPS}
        variant="outlined"
        margin="dense"
        style={{ margin: '0 8px', height: 32, minWidth: 64 }}
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>{opt}</MenuItem>
        ))}
      </Select>
      <span className="mrs-hint">
        {start}–{end} de <strong>{total}</strong>
      </span>
    </Box>
  );
};

export default ModalRowsSelect;
